export default "__VITE_ASSET__DZGLOMXW__"